import {
    AppState,
    DebugConsoleState,
    defaultRootState,
    IFeature,
    IFeaturesState,
    IFeaturesStateDataType,
    OverviewState,
    StoreState
} from "../models/states/AppStates";
import {
    ACTION_APP__CLEAR_LAST_STATE,
    ACTION_APP__GOTO_OVERVIEW,
    ACTION_APP__LOCAL_CHANGE,
    ACTION_APP__READY,
    ACTION_APP__RESTART,
    ACTION_APP__START,
    ACTION_DEBUG__CONSOLE_HIDE,
    ACTION_DEBUG__CONSOLE_SHOW,
    ACTION_FEATURES__CLEAR_ALL_URLS,
    ACTION_FEATURES__CLEAR_LAST_URL,
    ACTION_FEATURES__SET_DATA,
    ACTION_FEATURES__URL_CHANGE,
    ACTION_OVERVIEW__FEATURE_HIDE,
    ACTION_OVERVIEW__FEATURE_HIDE_ALL,
    ACTION_OVERVIEW__FEATURE_SHOW,
    ACTION_OVERVIEW__SET_DATA,
} from "../actions/Actions";
import {Action, combineReducers} from "redux";
import {AppMainStates} from "../models/Constants";
import {isType} from "typescript-fsa";
import {URLHelper} from "../helper/URLHelper";
import objectAssign = require('object-assign');

export class AppReducers
{
    static readonly allReducers = combineReducers<StoreState>({
        // maps automatically to the corresponding store objects by the keys like objName:object
        appState: AppReducers.appState,
        debugConsole: AppReducers.debugConsole,
        overview: AppReducers.overview,
        features: AppReducers.features,
    });

    static appState(state: AppState, action: Action): AppState
    {
        if (isType(action, ACTION_APP__START))
        {
            return {...state, mainState: AppMainStates.LOADING, content: action.payload.content};
        }
        else if (isType(action, ACTION_APP__READY))
        {
            return {...state};
        }
        if (isType(action, ACTION_APP__RESTART))
        {
            return {...state, mainState: AppMainStates.LOADING, content: action.payload};
        }
        // ------------------
        else if (isType(action, ACTION_APP__LOCAL_CHANGE))
        {
            // for development purpose
            if(URLHelper.isLocalDev)
            {
                URLHelper.dev_saveCurrentLocale(action.payload.newLocale);
            }
            return {...state, locale: action.payload.newLocale};
        }
        // ------------------
        else if (isType(action, ACTION_APP__GOTO_OVERVIEW))
        {
            return {...state, mainState: AppMainStates.OVERVIEW, lastMainState: state.mainState};
        }
        else if (isType(action, ACTION_APP__CLEAR_LAST_STATE))
        {
            return {...state, lastMainState: null};
        }

        return state ? state : defaultRootState.appState;
    }

    static debugConsole(state: DebugConsoleState, action: Action): DebugConsoleState
    {
        if (isType(action, ACTION_DEBUG__CONSOLE_SHOW))
        {
            return {...state, debugConsoleOpen: true};
        }
        else if (isType(action, ACTION_DEBUG__CONSOLE_HIDE))
        {
            return {...state, debugConsoleOpen: false};
        }

        return (state) ? state : {
            debugConsoleOpen: false
        };
    }

    static overview(state: OverviewState, action: Action): OverviewState
    {
        if (isType(action, ACTION_OVERVIEW__FEATURE_SHOW))
        {
            return {...state, currentSelectedLink: action.payload.link};
        }
        else if (isType(action, ACTION_OVERVIEW__FEATURE_HIDE))
        {
            return {...state, currentSelectedLink: ''};
        }
        else if (isType(action, ACTION_OVERVIEW__FEATURE_HIDE_ALL))
        {
            return {...state, currentSelectedLink: ''};
        }
        else if (isType(action, ACTION_OVERVIEW__SET_DATA))
        {
            return {...state, xmlObject: action.payload.data};
        }

        return state ? state : defaultRootState.overview;
    }

    static features(state: IFeaturesState, action: Action): IFeaturesState
    {
        if (isType(action, ACTION_FEATURES__SET_DATA))
        {
            return {...state, data: action.payload.data};
        }
        else if (isType(action, ACTION_FEATURES__URL_CHANGE))
        {
            const url: string = action.payload.url;
            const urlParts: string[] = url.substr(1).split("/");
            let currentFeature: IFeature;
            let currentFeatureDataType: IFeaturesStateDataType;

            // for development purpose
            if(URLHelper.isLocalDev)
            {
                URLHelper.dev_saveCurrentURL(url);
            }

            for (let i: number = 0, l: number = state.data.feature.length; i < l; i++)
            {
                let currentUrlParts: string[] = (state.data.feature[i]) ? state.data.feature[i].$.url.substr(1).split("/") : [];
                if (currentUrlParts.length < 2 || currentUrlParts[1] !== urlParts[1])
                {
                    continue;
                }

                currentFeature = state.data.feature[i];

                for (let j: number = 0, m: number = currentFeature.type.length; j < m; j++)
                {
                    currentUrlParts = (currentFeature.type[j]) ? currentFeature.type[j].$.url.substr(1).split("/") : [];
                    // Note: in case we have only 1 type, no type selection will be displayed
                    if (currentUrlParts.length > 2 && (currentUrlParts[2] === urlParts[2] || currentFeature.type.length == 1))
                    {
                        currentFeatureDataType = currentFeature.type[j];
                        break;
                    }
                }
                break;
            }

            return {
                ...state,
                currentURL: url,
                lastURL:state.currentURL,
                currentFeature: objectAssign({}, currentFeature),
                currentDataType: objectAssign({}, currentFeatureDataType),
            };
        }
        else if (isType(action, ACTION_FEATURES__CLEAR_ALL_URLS))
        {
            return {
                ...state,
                currentURL:'',
                lastURL:'',
            };
        }
        else if (isType(action, ACTION_FEATURES__CLEAR_LAST_URL))
        {
            return {
                ...state,
                lastURL:'',
            };
        }

        return state ? state : defaultRootState.features;
    }
}